<template>
  <div class="menu-page">
    <tableComponents
      :isHaveExport="false"
      :isShow="false"
      :isHavePagination="false"
      addText="新增节点"
      @toAdd="openEditor()"
    >
      <template #table>
        <el-table
          :data="menuList"
          row-key="id"
          border
          stripe
          default-expand-all
          :tree-props="{ children: 'children' }"
        >
          <el-table-column prop="title" label="节点标题" min-width="220" />
          <el-table-column label="节点类型" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="typeTagMap[row.type] || 'info'">
                {{ typeTextMap[row.type] || row.type }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="path" label="路由路径" min-width="180" />
          <el-table-column prop="permission_key" label="权限标识" min-width="180" />
          <el-table-column label="图标" width="90" align="center">
            <template slot-scope="{ row }">
              <i :class="row.icon || 'el-icon-menu'" class="menu-icon-preview"></i>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" width="80" align="center" />
          <el-table-column label="显示" width="90" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="Number(row.is_visible) === 1 ? 'success' : 'info'">
                {{ Number(row.is_visible) === 1 ? "显示" : "隐藏" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="210" align="center" fixed="right">
            <template slot-scope="{ row }">
              <el-button size="mini" type="primary" plain @click="openEditor(row)">
                编辑
              </el-button>
              <el-button size="mini" type="danger" plain @click="removeMenu(row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </tableComponents>

    <el-dialog
      :title="editorMode === 'edit' ? '编辑菜单节点' : '新增菜单节点'"
      :visible.sync="editorVisible"
      width="680px"
      @closed="resetEditor"
    >
      <el-form ref="menuForm" :model="editorForm" :rules="rules" label-width="110px">
        <el-form-item label="标题" prop="title">
          <el-input v-model.trim="editorForm.title" placeholder="请输入节点标题" />
        </el-form-item>

        <el-form-item label="节点类型" prop="type">
          <el-radio-group v-model="editorForm.type" @change="handleTypeChange">
            <el-radio label="catalog">目录</el-radio>
            <el-radio label="menu">页面</el-radio>
            <el-radio label="action">动作</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="父节点">
          <el-select
            v-model="editorForm.parent_id"
            clearable
            filterable
            placeholder="不选默认为根节点"
            style="width: 100%"
          >
            <el-option
              v-for="item in parentOptions"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item v-if="showPathField" label="路由路径" prop="path">
          <el-input v-model.trim="editorForm.path" placeholder="请输入页面路由路径" />
        </el-form-item>

        <el-form-item v-if="showPermissionField" label="权限标识" prop="permission_key">
          <el-input
            v-model.trim="editorForm.permission_key"
            placeholder="例如：admin_user:view"
          />
        </el-form-item>

        <el-form-item label="图标">
          <el-input
            v-model.trim="editorForm.icon"
            placeholder="例如：el-icon-user"
          />
        </el-form-item>

        <el-form-item label="排序">
          <el-input-number v-model="editorForm.sort" :min="0" :step="1" />
        </el-form-item>

        <el-form-item label="菜单显示">
          <el-switch
            v-model="editorForm.is_visible"
            :active-value="1"
            :inactive-value="0"
            :disabled="editorForm.type === 'action'"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitEditor">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapMenuOptions, normalizeMenuTree } from "@/utils/menu";

export default {
  data() {
    return {
      menuList: [],
      parentOptions: [],
      editorVisible: false,
      editorMode: "create",
      saving: false,
      editorForm: {
        id: "",
        title: "",
        type: "menu",
        path: "",
        permission_key: "",
        icon: "",
        sort: 0,
        is_visible: 1,
        parent_id: "",
      },
      typeTextMap: {
        catalog: "目录",
        menu: "页面",
        action: "动作",
      },
      typeTagMap: {
        catalog: "",
        menu: "success",
        action: "warning",
      },
      rules: {
        title: [{ required: true, message: "请输入节点标题", trigger: "blur" }],
        type: [{ required: true, message: "请选择节点类型", trigger: "change" }],
        path: [
          {
            validator: (rule, value, callback) => {
              if (this.editorForm.type !== "menu") {
                callback();
                return;
              }
              if (!value) {
                callback(new Error("页面节点必须填写路由路径"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        permission_key: [
          {
            validator: (rule, value, callback) => {
              if (this.editorForm.type !== "action") {
                callback();
                return;
              }
              if (!value) {
                callback(new Error("动作节点必须填写权限标识"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    showPathField() {
      return this.editorForm.type === "menu";
    },
    showPermissionField() {
      return this.editorForm.type === "menu" || this.editorForm.type === "action";
    },
  },
  methods: {
    async getList() {
      const data = await this.$api.getMenu.getAllMenuList();
      this.menuList = normalizeMenuTree(data.data || []);
      this.parentOptions = mapMenuOptions(this.menuList);
    },
    resetEditor() {
      this.$refs.menuForm && this.$refs.menuForm.resetFields();
      this.editorForm = {
        id: "",
        title: "",
        type: "menu",
        path: "",
        permission_key: "",
        icon: "",
        sort: 0,
        is_visible: 1,
        parent_id: "",
      };
    },
    handleTypeChange(type) {
      if (type === "catalog") {
        this.editorForm.path = "";
      }
      if (type === "action") {
        this.editorForm.path = "";
        this.editorForm.is_visible = 0;
      }
    },
    openEditor(row) {
      this.editorVisible = true;
      this.editorMode = row ? "edit" : "create";

      if (!row) {
        this.parentOptions = mapMenuOptions(this.menuList);
        return;
      }

      this.parentOptions = mapMenuOptions(this.menuList, [row.id]);
      this.editorForm = {
        id: row.id,
        title: row.title || "",
        type: row.type || "menu",
        path: row.path || "",
        permission_key: row.permission_key || "",
        icon: row.icon || "",
        sort: Number(row.sort || 0),
        is_visible: Number(row.is_visible || 0),
        parent_id: row.parent_id || "",
      };
    },
    normalizePayload() {
      const payload = {
        ...this.editorForm,
        sort: Number(this.editorForm.sort || 0),
        is_visible: Number(this.editorForm.is_visible || 0),
        parent_id: this.editorForm.parent_id || "",
      };

      if (payload.type === "catalog") {
        payload.path = "";
      }

      if (payload.type === "action") {
        payload.path = "";
        payload.is_visible = 0;
      }

      if (!this.showPermissionField) {
        payload.permission_key = "";
      }

      return payload;
    },
    async submitEditor() {
      const valid = await new Promise((resolve) => {
        this.$refs.menuForm.validate((result) => resolve(result));
      });
      if (!valid) {
        return;
      }

      this.saving = true;
      try {
        const payload = this.normalizePayload();
        const request = payload.id
          ? this.$api.getMenu.saveMenu(payload)
          : this.$api.getMenu.addMenu(payload);
        const data = await request;
        if (data.code === 200) {
          this.$message.success("保存成功");
          this.editorVisible = false;
          await this.getList();
          await this.$store.dispatch("refreshMenuTree");
        }
      } finally {
        this.saving = false;
      }
    },
    removeMenu(row) {
      this.$confirm(`确认删除节点 ${row.title} 吗？`, "删除确认", {
        type: "warning",
      }).then(async () => {
        const data = await this.$api.getMenu.delMenuItem({ id_str: row.id });
        if (data.code === 200) {
          this.$message.success("删除成功");
          await this.getList();
          await this.$store.dispatch("refreshMenuTree");
        }
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.menu-icon-preview {
  font-size: 18px;
  color: #1f5bbb;
}

/deep/ .el-table .el-table__cell {
  padding: 8px 0;
}
</style>
